import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { CV_JOB_FINDER_END_POINT } from "../../../../../config/config";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface rolesMatchedProps {
    id: number; 
    position_title : string; 
    client_name : string;
    matched_skills : number; 
    matched_cert: number; 
    matched_percentage : number;
}

interface UploadOptionsProps {
    callback_roles : (roles_matched : rolesMatchedProps[]) => void;
    callback_name : (name : string) => void;
}

const UploadOptions : React.FC<UploadOptionsProps> = ({callback_roles, callback_name}) => {

        //Job finder
        const [cvFile, setCvFile] = useState<File | null>(null);
        const [jfbLoader, setJfbLoader] = useState<boolean>(false);
        const cvInput = useRef<HTMLInputElement | null>(null);
        const [JsonText, setJsonText] = useState<string>('');

        useEffect(()=>{
            const uploadCv = async()=>{
            setJfbLoader(true);
            const formData = new FormData();
            if(cvFile) formData.append('file', cvFile);
            formData.append('json_text', JsonText);
            try{
                const upload_res = await api.post(CV_JOB_FINDER_END_POINT, formData, {
                    headers : {
                        'Authorization' : 'Bearer '+getToken()
                    }
                });
                const roles_matched = upload_res.data.roles_matched as {
                    id: number; 
                    position_title : string; 
                    client_name : string, 
                    matched_skills : number, 
                    matched_cert: number, 
                    matched_percentage : number
                }[];
                const name = upload_res.data.name as string;
                callback_roles(roles_matched);
                callback_name(name);
                setCvFile(null)
                setJfbLoader(false);
                setJsonText('')
                if(cvInput.current) cvInput.current.value = '';
            }catch(e){
                alert(`Failed to read the CV template. Please check the file and try again.`)
                setCvFile(null)
                setJfbLoader(false);
                setJsonText('')
                if(cvInput.current) cvInput.current.value = '';
            }
        }
        if(cvFile || JsonText !== '') uploadCv();
    },[JsonText, callback_name, callback_roles, cvFile])
    
    const handleUploadCv = (e : ChangeEvent<HTMLInputElement>) => {
        const cv = e.target.files;
        if(cv && cv.length > 0){
            if(cv[0].type === 'application/pdf'){
                setCvFile(cv[0]);
            }else{
                alert('Invalid file type');
            } 
        }
    }

    const handlePaste = async () => {
        try {
        const clipboardText = await navigator.clipboard.readText();
        setJsonText(clipboardText);
        } catch (err) {
        console.error('Failed to read clipboard: ', err);
        }
  };
        
    return(
        <div className="relative">
            <div className={jfbLoader ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="my-2 mb-4">
                Find Job Options
            </div>
            <div className="flex flex-col gap-4">
                <div>
                    <button type="button" onClick={handlePaste} className="button cursor-pointer button-vcc-primary text-sm">
                        Paste Copied JSON text
                    </button>
                </div>
                <div className="text-center">
                   <label htmlFor="cv_upload" className="button w-full cursor-pointer button-vcc-green text-sm">
                        Upload Formatted CV
                    </label>
                    <input type='file' ref={cvInput} id="cv_upload" accept="application/pdf" onChange={handleUploadCv} className="hidden" />
                </div>
            </div>
        </div>
    )
}

export default UploadOptions;